<template>
  <div>
    <!-- Header -->
    <Header
        :headerTitle="$t('m.overtimeOrder.title')"
        :hasBackBtn="true"
        :rightIconSrc="require('../../assets/img/dianhua.png')"
        :onRightBtnClick="call"
        :iconShow="true"
    ></Header>

    <div class="main-container" style="padding-top:5px">
      <!-- section -->
      <section>
        <div class="cardId">
          <h6>{{result.licenseplate}}</h6>
        </div>
        <div class="cardAddress">
          <h6>{{result.parkingName}}</h6>
          <p style="width:100%">{{result.parkingAddress}}</p>
        </div>
        <div class="money">
          <p>
            {{$t('m.overtimeOrder.inTime')}}
            <span>{{result.actualInTime}}</span>
          </p>
        </div>
        <div class="money">
          <p>
            {{$t('m.overtimeOrder.outTime')}}
            <span>{{result.actualOutTime}}</span>
          </p>
        </div>
        <div class="money">
          <p>
            {{$t('m.overtimeOrder.dateAndMoney')}}
            <span>{{result.appointTime/60}} {{$t('m.overtimeOrder.hours')}} | {{result.amount}} {{$t('m.overtimeOrder.CNY')}}</span>
          </p>
        </div>
        <div class="money">
          <p>
            {{$t('m.overtimeOrder.overTimeMoneyTitle')}}
            <img src="../../assets/img/gantan.png" width="14">
            <span
                style="color:#0066B1;font-size:12px"
            >{{$t('m.overtimeOrder.overTime')}}{{(result.timeoutTime/60).toFixed(2)}} {{$t('m.overtimeOrder.hours')}} | {{result.timeoutAmount}}{{$t('m.overtimeOrder.CNY')}}</span>
          </p>
        </div>

         <div class="money">
          <p>
            {{$t('m.overtimeOrder.chargeMoneyTitle')}}
            <span
                style="color:#0066B1;font-size:12px"
            >{{result.chargeAmount}} {{$t('m.overtimeOrder.CNY')}}</span>
          </p>
        </div>
      </section>
      <footer @click="wxPay">
        <b-button href="#" variant="primary" width="100%">
          {{$t('m.overtimeOrder.goPay')}}
          <span>{{result.actualPayAmount}}</span>{{$t('m.overtimeOrder.CNY')}}
        </b-button>
      </footer>
    </div>
    <!--mobile modal -->
    <b-modal
        ref="myModalRef"
        id="messageBox"
        centered
        :ok-title="$t('m.phone.call')"
        :title="$t('m.phone.serviceTitle')"
        :cancel-title="$t('m.phone.cancel')"
        @ok="handleOk"
    >{{phone}}
    </b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>

</template>
<script>
  import {orderListByDetails, goPay} from "../../api/order.js"
  import {
  	getBrowserType,getLonLat
  } from '@/utils/common.js'

  export default {
    name: "OvertimeOrder",
    data() {
      return {
        result: [], //数据
        orderId: "", //订单Id
        wxPayData: {}, //微信
        phone: "400-115-0606", //电话
        message: "", //提示信息
        tipShow: "0", //是否提示
        tipType: "", //提示类型
        ostatus: null
      };
    },
    methods: {
      //微信支付接口
      loadOrderOvertime: function () {
        //数据方法
        orderListByDetails({orderId: this.orderId}).then(
            response => {
              if (response.data.status == 200) {
                this.result = response.data.result;
              } else {
                if (this.ostatus != null) {
                  clearInterval(this.ostatus);
                }
                this.tipShow = "1" + Math.random() * 1000;
                this.message = response.data.message;
                this.tipType = "warning";
              }
            },
            err => {
              reject(err);
            }
        );
      }, //去支付操作
      wxPay() {
        goPay({orderId: this.orderId}).then(response => {
          if (response.data.status == 200) {
            if (response.data.result.isFree) {
              if (response.data.result.isFree == 1) {
                this.tipShow = "1" + Math.random() * 1000;
                this.message = this.$t('m.overtimeOrder.paySuccess');
                this.tipType = "success";
                if (this.ostatus != null) {
                  clearInterval(this.ostatus);
                }
                setTimeout(_ => {
                  this.$router.push("/");
                }, 1100);
                return;
              }
            }
            this.wxPayData =
                response.data.result.prePayInfoResponse.wechatPrePayInfo;
			let browserType = getBrowserType()
            if(browserType === 1) {
              // 微信内浏览器支付
              if (typeof WeixinJSBridge == "undefined") {
            	if (document.addEventListener) {
            	  document.addEventListener(
            		  "WeixinJSBridgeReady",
            		  this.onBridgeReady,
            		  false
            	  );
            	} else if (document.attachEvent) {
            	  document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
            	  document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            	}
              } else {
            	this.onBridgeReady();
              }
            } else if (browserType === 2) {
              // 微信外手机浏览器支付
              window.location.href = this.wxPayData.mwebUrl;
            } else if (browserType === 3) {
              // PC 浏览器支付, 暂不支持
            } else if (browserType === 4 || browserType === 5) {
              // 调用原生方法
              pay(response.data.result.prePayInfoResponse.orderNo, {
            	packageVal: 'Sign=WXPay',
            	appid: this.wxPayData.appId,
            	sign: this.wxPayData.sign,
            	partnerid: this.wxPayData.prePayId,
            	prepayid: this.wxPayData.partnerId,
            	noncestr: this.wxPayData.nonceStr,
            	timestamp: this.wxPayData.timestamp
              }, 4)
            }
          } else {
            if (this.ostatus != null) {
              clearInterval(this.ostatus);
            }
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        });
      },
      //微信信息
      onBridgeReady() {
        WeixinJSBridge.invoke("getBrandWCPayRequest", {
          appId: this.wxPayData.appId, //公众号名称，由商户传入
          timeStamp: this.wxPayData.timestamp, //时间戳，自1970年以来的秒数
          nonceStr: this.wxPayData.nonceStr, //随机串
          package: this.wxPayData.extra,
          signType: "HMACSHA256", //微信签名方式：
          paySign: this.wxPayData.sign
        });
      },
      //修改状态
      orderStatus() {
        let this_s = this;
        //轮询订单状态
        this.ostatus = setInterval(function () {
          orderListByDetails({orderId: this_s.orderId}).then(response => {
            let data = response.data;
            if (data.status == 200) {
              if (data.result.status == 6) {
                clearInterval(this.ostatus);
                if (data.result.entranceWay == 1) {
                  this.$router.push("/gotoLeaveVoucher/" + this.orderId);
                } else {
                  window.history.back(); //返回上一页
                }
              }
            } else {
              if (this.ostatus != null) {
                clearInterval(this.ostatus);
              }
              this.tipShow = "1" + Math.random() * 1000;
              this.message = response.data.message;
              this.tipType = "warning";
            }
          });
        }, 2000);
      },
      call() {
        this.$refs.myModalRef.show();
      },
      handleOk: function () {
        window.location.href = "tel:" + this.phone;
      }
    },
    //加载事件
    created() {
      this.orderId = this.$route.params.orderId; //订单Id
      this.loadOrderOvertime();
      this.orderStatus();
    },
    //离开页面事件
    destroyed() {
      if (this.ostatus != null) {
        clearInterval(this.ostatus);
      }
    }
  };
</script>
<style>
  header,
  section p {
    margin: 0 auto;
    padding: 0;
  }

  header {
    text-align: center;
    font-size: 19px;
    color: black;
    padding: 10px;
    padding-bottom: 5px;
  }

  header .return {
    display: inline-block;
    float: left;
    vertical-align: middle;
    font-size: 14px;
  }

  header .title {
    text-align: center;
  }

  header .imgIco {
    display: inline-block;
    float: right;
  }

  section {
    margin-bottom: 50px;
  }

  section .cardId {
    border-bottom: 2px solid #efefef;
    padding: 5px 0;

    text-align: left;
  }

  section .cardId h6 {
    font-size: 14px;
    display: inline-block;
  }

  section .cardAddress {
    padding: 10px 0;
    text-align: left;
    border-bottom: 2px solid #efefef;
  }

  section .cardAddress h6 {
    margin: 0 auto;
    padding: 0px;
    font-size: 14px;
  }

  section .cardAddress p {
    font-size: 13px;
    color: #666;
    font-size: 11px;
  }

  footer .btn-primary {
    color: #fff;
    background-color: #0066B1;
    width: 100%;
    /* line-height: 30px; */
  }
</style>


